var map = {
	"./carousal.svg": "132f",
	"./drag-item.svg": "a6f7",
	"./image-post.svg": "0090",
	"./info-icon.svg": "6f31",
	"./instagram-carousel-icon-active-blue.svg": "90a8",
	"./instagram-carousel-icon-active.svg": "9e8de",
	"./instagram-feed-icon-active-blue.svg": "6e4e",
	"./instagram-feed-icon-active.svg": "e9c7",
	"./instagram-feed-icon.svg": "e0ef",
	"./instagram-reels-icon-active-blue.svg": "4b1d5",
	"./instagram-reels-icon-active.svg": "8fac",
	"./instagram-reels-icon.svg": "c690",
	"./instagram-reels-plus-feed-icon-active-blue.svg": "cbda",
	"./instagram-reels-plus-feed-icon-active.svg": "2228",
	"./instagram-reels-plus-feed-icon-blue.svg": "24e8",
	"./instagram-stories-icon-active-blue.svg": "3204e",
	"./instagram-stories-icon-active.svg": "139f",
	"./instagram-stories-icon.svg": "9558",
	"./mutual-follow-friends.svg": "08fc",
	"./tiktok-feed-icon-active-blue.svg": "a1f1",
	"./tiktok-feed-icon-active.svg": "7798",
	"./tiktok-feed-icon.svg": "5ca4",
	"./tiktok-self-icon-active-blue.svg": "0576",
	"./tiktok-self-icon-active.svg": "ef190",
	"./tiktok-self-icon.svg": "d931",
	"./video-play.svg": "4c31"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5853";